module.exports = __webpack_public_path__ + "static/img/logo_dg.fb825e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_dg.png
// module id = oE4I
// module chunks = 1